<mat-toolbar fxLayoutAlign="space-between center" fxLayout="row" color="primary">
  <span>Editor</span>
  <button [attr.guide]="'text-editor-btn-1' + '__' + sanitizeUrl(url)" (click)="close(field)" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>


<div [formGroup]="_form">

  <div style="overflow-y:auto"  class=" products-padding">

<!-- <angular-editor formControlName="value" [config]="editorConfig"></angular-editor> -->
<div class="scrollY">

<calsoft-doc-editor
  formControlName="value"
  [mode]="'compose'">
</calsoft-doc-editor>
    </div>
  </div>
  <div class=" products-padding" fxLayoutGap="10px">
    <button [attr.guide]="'text-editor-btn-2' + '__' + sanitizeUrl(url)" type="button" mat-raised-button color="primary" (click)="confirm(group,field)">OK
    </button>
  </div>

 
</div>


<!-- <div [formGroup]="_form">
  <div style="overflow-y:auto" class="products-padding">
    <div class="scrollY">
      <calsoft-angular-editor
        id="editor1"
        formControlName="value"
        autofocus="true"
        [config]="config1"
        (ngModelChange)="onChange($event)"
        (blur)="onBlur($event)">
        <ng-template #customButtons let-executeCommandFn="executeCommandFn">
          <calsoft-ae-toolbar-set>
            <calsoft-ae-button
              iconClass="code"
              title="Angular editor logo"
              (buttonClick)="executeCommandFn('insertHtml', angularEditorLogo)">
            </calsoft-ae-button>
          </calsoft-ae-toolbar-set>
        </ng-template>
      </calsoft-angular-editor>
    </div>
  </div>
  
  <div class="products-padding" fxLayoutGap="10px">
    <button [attr.guide]="'text-editor-btn-3' + '__' + sanitizeUrl(url)" type="button" mat-raised-button color="primary" (click)="confirm(group,field)">
      OK
    </button>
  </div>
</div> -->